export default [
  {
    path: 'afiliados/liquidacao-contratos',
    name: 'liquidacao-contratos',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Liquidação Financeira',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Relatórios', link: 'relatorios' },
        { name: 'Liquidação de Contratos' },
      ]
    }
  },
]